import { AtelierLink } from '@/components/admin/vitrine/atelier-link';
import { useInstanceContext } from '@/lib/use-instance';
import { VITRINE_WORDING, atelierHref } from '@/lib/vitrine';
import { useRouterState } from '@tanstack/react-router';

/**
 * What stands in the place of the dry trials of a session on the vitrine
 * (docs/specs/vitrine.md section 7, H8, maquette `vitrine.html` section 5).
 *
 * « Lecture à blanc » (the analyst) and « Rangement à blanc » (the ranger) are
 * paid calls, and the vitrine makes none: the two sections leave, and this note
 * says where they went - to form.dev, on the same session once it has gone up
 * (a session of the vitrine reaches the atelier at the hourly synchronisation,
 * or at once on « Synchroniser »). The button opens THAT session on the atelier:
 * the same path, the identifier of a session being the same on both servers.
 *
 * Without an atelier address the sentence stays and the button goes: a link to
 * nowhere would be worse than none.
 */

export function VitrineTrialsNote() {
  const { atelierOrigin } = useInstanceContext();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const href = atelierHref(atelierOrigin, pathname, '');
  return (
    <div
      data-testid="vitrine-essais"
      className="flex flex-wrap items-center gap-x-3 gap-y-1.5 border-l-4 border-l-bleu-ciel-deep bg-bleu-ciel-tint px-3 py-2 text-bleu-ciel-deep text-sm"
    >
      <p className="min-w-55 flex-1">{VITRINE_WORDING.trialsNote}</p>
      {href === null ? null : (
        <AtelierLink href={href} data-testid="vitrine-ouvrir-session">
          {VITRINE_WORDING.openSessionAtelier}
        </AtelierLink>
      )}
      <p className="basis-full text-xs leading-4 opacity-85">{VITRINE_WORDING.trialsHint}</p>
    </div>
  );
}
